module.exports = require('./helpers/bundle-url').getBundleURL('1Xqbz') + "logo.c51670a8.svg";